import { gql } from 'apollo-boost'
import { ID } from '../id.type'

export interface CreateQuoteSignatureData {
  signature: {
    id: ID
    status: string
  }
}

export interface CreateQuoteSignatureVariables {
  quote: ID
  accessKey?: string
  signature: {
    email: string
    iban: string
    mobile: string
    paymentTerm: string
    riskStartDate: string
    canceledContract: boolean
    otherContract: boolean
    electronicCommunication: boolean
  }
}

export const CREATE_QUOTE_SIGNATURE_MUTATION = gql`
  mutation requestSignature($quote: ID!, $signature: CreateQuoteSignatureInput!, $accessKey: String) {
    signature: createQuoteSignature(quote: $quote, signature: $signature, accessKey: $accessKey) {
      id
      status
    }
  }
`
